"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var EventType_1 = require("../../model/types/EventType");
var Id_1 = require("../types/Id");
var AbstractEvent_1 = require("./AbstractEvent");
var HomeSearchResultsViewedEvent = (function (_super) {
    __extends(HomeSearchResultsViewedEvent, _super);
    function HomeSearchResultsViewedEvent(homeIds, queryId) {
        var _this = _super.call(this) || this;
        _this.props = new HomeSearchResultsViewedEventProperties(homeIds.map(function (i) { return new Id_1.Id(i); }), queryId);
        return _this;
    }
    HomeSearchResultsViewedEvent.prototype.getType = function () {
        return EventType_1.EventType.HomeSearchResultsViewed;
    };
    return HomeSearchResultsViewedEvent;
}(AbstractEvent_1.AbstractEvent));
exports.HomeSearchResultsViewedEvent = HomeSearchResultsViewedEvent;
var HomeSearchResultsViewedEventProperties = (function () {
    function HomeSearchResultsViewedEventProperties(home_ids, query_id) {
        this.home_ids = home_ids;
        this.query_id = query_id;
    }
    return HomeSearchResultsViewedEventProperties;
}());
//# sourceMappingURL=HomeSearchResultsViewedEvent.js.map